import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_CASE_BY_ID = 'GET_CASE_BY_ID';
export const GET_CASE_BY_ID_SUCCESS = 'GET_CASE_BY_ID_SUCCESS';
export const GET_CASE_BY_ID_FAIL = 'GET_CASE_BY_ID_FAIL';
export const GET_CASE_BY_ID_RESET = 'GET_CASE_BY_ID_RESET';

export const getCaseById = (params) => {
	return {
		type: GET_CASE_BY_ID,
		params,
	};
};

export const getCaseByIdSuccess = (response) => {
	return {
		type: GET_CASE_BY_ID_SUCCESS,
		response,
	};
};

export const getCaseByIdFail = (response) => {
	return {
		type: GET_CASE_BY_ID_FAIL,
		response,
	};
};

export const getCaseByIdReset = () => {
	return {
		type: GET_CASE_BY_ID_RESET,
	};
};

export const getCaseByIdApi = (data) => {
	return (dispatch) => {
		dispatch(getCaseById());
		axios
			.get(`${config.api.base_url}/case/${data.id}`, {
				params: { new_case: data.new_case },
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getCaseByIdData = response.data;
				dispatch(getCaseByIdSuccess(getCaseByIdData));
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch(getCaseByIdFail(errorMsg));
			});
	};
};
